import React from "react";
import styles from "./PageChrome.module.css";

// Blue bar shown while rows are ticked: the count, the page's batch actions, and Clear selection.
export default function BatchBar({ count, onClear, children }) {
  if (!count) return null;
  return (
    <div className={styles.batchBar} role="region" aria-label="Batch actions">
      <span className={styles.batchCount}>{count} selected</span>
      {children}
      <button type="button" className={styles.batchClear} onClick={onClear}>
        Clear selection
      </button>
    </div>
  );
}
